import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_router_outlet),
      _createVNode(_component_ion_alert, {
        "is-open": _ctx.showInstallDialog,
        header: "App installieren",
        message: "Möchtest du die App auf deinem Startbildschirm installieren?",
        buttons: _ctx.installDialogButtons,
        onDidDismiss: _ctx.onInstallDialogDismiss
      }, null, 8, ["is-open", "buttons", "onDidDismiss"])
    ]),
    _: 1
  }))
}